<template>
  <div class="rectangle">
    <p>
      Si necesitas ayuda para construir la entrevista puedes consultar el
      <a :href="serverPath + employee.core_employee.society.work_regulations" target="_blank">
        <span class="link-questions">reglamento de trabajo</span>
      </a>
      también el
      <span class="link-questions" @click="showModal"
        >repositorio de preguntas</span
      >
    </p>

    <b-modal
      id="modal-1"
      ref="modal-1"
      scrollable
      hide-footer
      size="lg"
      title="Repositorio de preguntas"
    >
      <div class="m-4 px-5">
        <div class="row">
          <div class="col-4">
            <small>Temática</small>
            <select class="custom-select mb-3" v-model="selectedCategory">
              <option value="0">Todos</option>
              <option
                v-for="category in categories"
                v-bind:key="category.id"
                v-bind:value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>
          <div class="col-8 mb-md-5">
            <small>Palabras clave</small>
            <input
              type="text"
              placeholder="Escribe palabras clave para tu búsqueda"
              class="form-control"
              v-model="textFilter"
            />
          </div>
        </div>
        <h3>Preguntas sugeridas</h3>
        <div>
          <ul class="list-group">
            <li
              class="list-group-item"
              v-for="question in filterQuestions"
              :key="question.id"
            >
              <div class="question d-flex justify-content-between">
                <p>{{ question.question }}</p>
                <button
                  class="btn btn-outline-info"
                  :class="{ 'btn-active': question.enabled }"
                  @click="changeState(question.id)"
                >
                  <span class="icon icon-anadir mx-2"></span>{{question.enabled ? "Añadida" : "Añadir"}}
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "QuestionRepository",
  props: {},
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      selectedCategory: 0,
      textFilter: "",
      activeQuestion: true,
    };
  },
  computed: {
    ...mapState("modProcessEmployee", ["process","employee","categories", "questions"]),
    filterQuestions() {
      if (this.activeQuestion) {
        if (this.selectedCategory == 0) {
          return this.questions.filter((question) =>
            question.question.includes(this.textFilter)
          );
        } else {
          return this.questions.filter(
            (question) =>
              question.proce_question_category_id == this.selectedCategory &&
              question.question.includes(this.textFilter)
          );
        }
      } else {
        return this.questions;
      }
    },
  },
  methods: {
    ...mapActions("modProcessEmployee", [
      "actGetQuestionCategories",
      "actGetQuestions",
    ]),
    changeState(id) {
      this.activeQuestion = false;
      let questionSelected = this.questions.find((question) => question.id === id)
      if(!questionSelected.enabled){
        this.process.template = this.process.template.replace("{{***}}", `<p style="text-align:justify;"><strong>PREGUNTA:&nbsp;</strong><span>${questionSelected.question}</span></p><p style="text-align:justify;"><strong>RESPUESTA:</strong></p><p style="text-align:justify;">{{***}}</p>`);
      }
      questionSelected.enabled = true;
      this.activeQuestion = true;
    },
    showModal() {
      this.activeQuestion = false;
      this.questions.forEach((question) => question.enabled = false);
      this.activeQuestion = true;
      this.$refs["modal-1"].show();
    },
  },
  beforeMount() {
    this.actGetQuestionCategories();
    this.actGetQuestions();
  },
};
</script>
<style scoped>
.rectangle {
  text-align: center;
  padding: 10px 5px;
  background: #fff3cd;
  border-radius: 4px;

  font-family: Open Sans;

  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #816208;
}
.link-questions {
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
  color: #816208;
}
.question p {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #454545;
}
.btn-outline-info {
  color: #1c3a4e !important;
  border-color: #1c3a4e !important;
  font-size: 14px;
  line-height: 21px;
}

.btn-outline-info:hover {
  background-color: #1c3a4e !important;
  color: #fff !important;
}

.btn-active {
  background-color: #779b49 !important;
  color: #fff !important;
}
</style>
